import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";
import { useFloatingPortalContainer } from "@frontend/contexts";

import type { PopoverPortalProps } from "./Popover.types";

export function PopoverPortal({
  children,
  ...props
}: PopoverPortalProps): JSX.Element {
  const container = useFloatingPortalContainer();

  return (
    <BasePopover.Portal
      data-slot="popover-portal"
      container={container}
      {...props}
    >
      {children}
    </BasePopover.Portal>
  );
}
